import store from "../store";
import log from "../utils/log";
import {
	appRequestConfig,
	appRequestConfigEnd,
	appRequestI18n,
	appRequestI18nEnd,
	appRequestUserlistEnd
} from "../actions/appActions";
import appDao from "./appDao";
import { httpRequest, baseName } from "../utils/config";
import i18nUtils from "../utils/i18n";
import { axiosInstanceToken } from "../utils/axios";

const appApi = {
	getConfig() {
		log.log("[appApi.getConfig] START");

		store.dispatch(appRequestConfig());

		let appDaoCall = appDao.getConfig(window.location.host);
		// let appDaoCall = appDao.getConfig("test4");

		appDaoCall
			.then(function(config) {
				log.log("[appApi.getConfig] END", config);
				// setup background image url
				if (httpRequest.port) {
					config.backgroundImageURL =
						httpRequest.serverAddress +
						":" +
						httpRequest.port +
						httpRequest.serverPath +
						config.backgroundImageURL;
					// setup logo image url
					config.logoImageURL =
						httpRequest.serverAddress +
						":" +
						httpRequest.port +
						httpRequest.serverPath +
						config.logoImageURL;
				} else {
					config.backgroundImageURL =
						httpRequest.serverAddress +
						"/" +
						config.backgroundImageURL;
					// setup logo image url
					config.logoImageURL =
						httpRequest.serverAddress + "/" + config.logoImageURL;
				}
				store.dispatch(appRequestConfigEnd(config));
			})
			.catch(function(e) {
				store.dispatch(appRequestConfigEnd());
			});
	},
	getI18n() {
		log.log("[appApi.getI18n] START");

		store.dispatch(appRequestI18n());

		let appDaoCall = appDao.getI18n(baseName, navigator.language);

		appDaoCall
			.then(function(i18n) {
				log.log("[appApi.getI18n] END", i18n);
				// setup background image url
				i18nUtils.initTranslation(navigator.language, i18n);

				store.dispatch(appRequestI18nEnd(i18n));
			})
			.catch(function() {
				store.dispatch(appRequestI18nEnd());
			});
	},
	getAnnouncement() {
		log.log("[appApi.getAnnouncement] START");

		let appDaoCall = appDao.getAnnouncement();

		appDaoCall.then(function(announcement) {
			log.log("[appApi.getAnnouncement] END", announcement);
		});
		return appDaoCall;
	},
	getUserList() {
		log.log("[appApi.getUserList] START");

		if (axiosInstanceToken) {
			let appDaoCall = appDao.getUserlist();

			appDaoCall
				.then(function(userList) {
					log.log("[appApi.getUserList] END", userList);

					store.dispatch(appRequestUserlistEnd(userList));
				})
				.catch(function() {
					store.dispatch(appRequestUserlistEnd());
				});
			return appDaoCall;
		}
		return null;
	},
	checkUserToken(token) {
		log.log("[appApi.checkUserToken] START");

		if (axiosInstanceToken) {
			let appDaoCall = appDao.checkUserToken(token);
			appDaoCall.then().catch();
			return appDaoCall;
		}
		return null;
	}
};

export default appApi;



// WEBPACK FOOTER //
// ./src/api/appApi.js